module.exports = __webpack_public_path__ + "img/dod.acb65541.jpg";